// This file is auto-generated by the `scripts/wallets/generate.ts` script.
// Do not modify this file manually.
export const wallet = {
    id: "app.herewallet",
    name: "HERE Wallet",
    homepage: "https://herewallet.app",
    image_id: "21cadc07-2f45-4860-3358-83a2057b6300",
    app: {
        browser: null,
        ios: "https://download.herewallet.app?ios",
        android: "https://download.herewallet.app?android",
        mac: "",
        windows: null,
        linux: null,
        chrome: null,
        firefox: null,
        safari: null,
        edge: null,
        opera: null,
    },
    rdns: null,
    mobile: {
        native: "herewallet://",
        universal: "https://my.herewallet",
    },
    desktop: {
        native: null,
        universal: null,
    },
};
//# sourceMappingURL=index.js.map